export const store = {
  // Vazio até a loja definir o e-mail de atendimento: os links de e-mail ficam ocultos.
  email: '',
  whatsapp: 'https://wa.me/5511974876232',
  phone: '(11) 97487-6232',
  cnpj: '48.121.217/0001-86',
  legalName: 'BOZZETTI STORE CONFECÇÕES LTDA',
  address: 'Rua Silva Teles, 436, Loja 438 A, Pari, São Paulo/SP, CEP 03026-000',
  units: [
    { name: 'Silva Teles', address: 'Silva Teles, 438 A', mapQuery: 'Rua Silva Teles 438 São Paulo SP' },
    { name: 'Largo da Concórdia', address: 'Largo da Concórdia, 107, Setor Y, Loja 10', mapQuery: 'Largo da Concórdia 107 São Paulo SP' },
  ],
};
